import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import PropTypes from "prop-types";
import classNames from "classnames";
import LogoTag from "./components/LogoTag";
import logo from "@/assets/images/logo.png";
import { useSession } from "next-auth/client";

const Logo = ({ tag, isInNavbar, iconOnly, iconWidth }) => {
  const [session] = useSession();
  const isAdmin = !session
    ? null
    : session?.user?.roles?.find((role) => role?.role === "Admin");

  const t = useTranslations();
  return (
    <LogoTag
      tag={tag}
      to={!session ? "/" : isAdmin ? "/admin/events" : "/user"}
      className={classNames({
        brand: !isInNavbar,
        "navbar-brand": isInNavbar,
      })}>
      <span
        className={classNames({
          logo: !isInNavbar,
          "navbar-logo": isInNavbar,
        })}>
        <Image src={logo} alt="Currinda" width={iconWidth} height={iconWidth} />
      </span>
      {!iconOnly && (
        <>
          <b>{t("common.currinda")}</b>
          <small>{t("common.keepingTrack")}</small>
        </>
      )}
    </LogoTag>
  );
};

Logo.propTypes = {
  to: PropTypes.string,
  tag: PropTypes.oneOf(["a", "div"]),
  iconWidth: PropTypes.number,
  iconOnly: PropTypes.bool,
  isInNavbar: PropTypes.bool,
};

Logo.defaultProps = {
  to: "/",
  tag: "div",
  iconWidth: 25,
  iconOnly: false,
  isInNavbar: false,
};

export default Logo;
